import styled, { keyframes } from 'styled-components';
import { colors, spacing, mediumShadow, body2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const slideCards = keyframes`
  0%, 16.67% { transform: translateY(0); }
  20%, 37% { transform: translateY(-16.67%); }
  41%, 58% { transform: translateY(-33.33%); }
  62%, 79% { transform: translateY(-50%); }
  83%, 100% { transform: translateY(0); }
`;

export const slideCardsDelayed = keyframes`
  0%, 17.17% { transform: translateY(0); }
  20.5%, 37.5% { transform: translateY(-16.67%); }
  41.5%, 58.5% { transform: translateY(-33.33%); }
  62.5%, 79.5% { transform: translateY(-50%); }
  83.5%, 100% { transform: translateY(0); }
`;

export const spin = keyframes`
  from { --angle: 0deg; }
  to { --angle: 360deg; }
`;

const gradient = `
  conic-gradient(from var(--angle), 
  transparent 0%,
  transparent 28.75%,
  #CAF3E7 33.75%,
  #CAF3E7 71.25%,
  transparent 76.25%,
  transparent 100%
)`;

export const AnimatedBorderCardContainer = styled.div`
  position: relative;
  border-radius: ${spacing.quarter};
  width: ${pxToRem(490)};
  height: ${pxToRem(60)};
  padding: ${spacing.eighth};

  @property --angle {
    syntax: '<angle>';
    initial-value: 0deg;
    inherits: false;
  }

  &::after,
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: ${spacing.quarter};
    background: ${gradient};
    animation: ${spin} 3s cubic-bezier(0.1, 0.1 , 0.9, 1) infinite;
  }

  &[data-static="true"] {
    &::after,
    &::before {
      background: none !important;
      animation: none !important;
    }
  }

  &::before {
    filter: blur(1.5rem);
    opacity: 0.2;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${spacing.base};

  > div:not(:nth-child(2)) {
    position: relative;
    
    opacity: 0.35;
  }

  > div:nth-child(2) {      
    margin-right: ${spacing.double};
  }
`;

export const ContainerText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: ${spacing.double};
`;

export const ContainerBody = styled.div`
${body2};
color: ${colors.textSecondary};
`;

export const AnimatedBorderCardContentWrapper = styled.div`
  position: relative;
  overflow: hidden;
  ${mediumShadow};
  background: ${colors.backgroundPrimary};
  border-radius: ${spacing.quarter};
  z-index: 1;
  height: 100%;
`;

export const TrackWrapper = styled.div`
  margin-top: 16px;
  width: ${pxToRem(486)};
  height: ${pxToRem(24)};
  position: relative;
  overflow: hidden;
  z-index: 1;
`;

export const Track = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 600%;
  animation: ${slideCards} 15s infinite;
  will-change: transform;
  z-index: 2;

  &[data-delayed="true"] {
    animation: ${slideCardsDelayed} 15s infinite;
  }

  &[data-static="true"] {
    animation: none;
    height: 100%;
  }

  &[data-delayed="true"][data-static="true"] {
    > div {
      height: 100%;
    }
  }
`;

export const StyledTrack = styled(Track)`
    padding-left: ${spacing.base};
`;

export const Card = styled.div`
  width: 100%;
  height: 25%;
  background: transparent;
  color: ${colors.textPrimary};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0;

  &[data-destination-name="true"] {
    min-height: ${spacing.plusHalf};
    background: ${colors.backgroundPrimary};
    justify-content: flex-start;
    padding-left: ${spacing.x3};
  }

  &[data-static="true"] {
    height: 100%;
  }
  > div {
    height: 100%;
  }
`;

export const StatusSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  color: ${colors.textSecondary};
  font-size: ${pxToRem(14)};
  height: 100%;
  z-index: 3;
  justify-content: end;
  padding-right: ${spacing.base};
  background: white;
`;
